export default "__VITE_ASSET__B9GBS9uk__"